module.exports = __webpack_public_path__ + "img/esmeralda-hotel.142c0c7d.jpg";